import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export default function SuspendedGate({ shop, reason }) {
  return (
    <div className="min-h-screen bg-void text-white flex items-center justify-center p-6">
      <div className="glass-strong rounded-2xl p-10 max-w-lg text-center" data-testid="suspended-gate">
        <div className="w-12 h-12 mx-auto rounded-full border border-gold/40 bg-void flex items-center justify-center gold-glow">
          <ShieldAlert className="w-5 h-5 text-gold" strokeWidth={1.5} />
        </div>
        <div className="font-numbers text-[10px] tracking-[0.4em] uppercase text-gold mt-5">
          {reason === "blocked" ? "Account Blocked" : reason === "expired" ? "Subscription Expired" : "Service Suspended"}
        </div>
        <h1 className="font-heading text-3xl md:text-4xl mt-3">
          Service Temporarily Suspended
        </h1>
        <p className="mt-4 text-white/60">
          {shop?.name ? `"${shop.name}" — ` : ""}please contact <strong className="text-gold">AIBoxHub.in</strong> to restore service.
        </p>
        <Link to="/" className="btn-ghost inline-flex items-center gap-2 mt-8 text-sm">
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}
